export const userAgent = '';
//# sourceMappingURL=navigator_node.js.map